export const TOPIC_EXAMPLES = [
  'AI/ML',
  'Startups',
  'Crypto/Blockchain',
  'Climate tech',
  'Product management',
  'SaaS',
  'Fintech',
  'Venture capital',
  'Web3',
  'Biotech',
  'Cybersecurity',
  'E-commerce',
  'Developer tools',
  'Open source',
  'Data science',
  'DevOps',
  'AR/VR',
  'Cloud computing',
  'Mobile dev',
  'Kubernetes',
  'Leadership',
  'Marketing',
  'Sales',
  'Design',
  'Growth hacking',
  'Fundraising',
  'M&A',
  'IPOs',
  'HealthTech',
  'EdTech',
  'Gaming',
  'Social media',
  'B2B SaaS',
  'Enterprise software',
  'Quantum computing',
  'Content marketing',
  'SEO',
  'Paid ads',
  'Email marketing',
  'Community building',
  'Brand strategy',
  'Product-led growth',
  'Product strategy',
  'A/B testing',
  'Hiring',
  'Company culture',
  'Team building',
  'Customer success',
];

export const ACCOUNT_EXAMPLES: [string, string][] = [
  ['@paulg', 'Paul Graham'],
  ['@elonmusk', 'Elon Musk'],
  ['@naval', 'Naval Ravikant'],
  ['@sama', 'Sam Altman'],
  ['@hubermanlab', 'Andrew Huberman'],
  ['@lexfridman', 'Lex Fridman'],
  ['@pmarca', 'Marc Andreessen'],
  ['@peterthiel', 'Peter Thiel'],
  ['@mcuban', 'Mark Cuban'],
  ['@alexisohanian', 'Alexis Ohanian'],
  ['@jasonfried', 'Jason Fried'],
  ['@dhh', 'David Heinemeier Hansson'],
  ['@jack', 'Jack Dorsey'],
  ['@jason', 'Jason Calacanis'],
  ['@garrytan', 'Garry Tan'],
  ['@ycombinator', 'Y Combinator'],
  ['@balajis', 'Balaji Srinivasan'],
  ['@cdixon', 'Chris Dixon'],
  ['@a16z', 'Andreessen Horowitz'],
  ['@sequoia', 'Sequoia Capital'],
  ['@benedictevans', 'Benedict Evans'],
  ['@benthompson', 'Ben Thompson'],
  ['@patrick_oshag', "Patrick O'Shaughnessy"],
  ['@wolfejosh', 'Josh Wolfe'],
  ['@chamath', 'Chamath Palihapitiya'],
  ['@davidssacks', 'David Sacks'],
  ['@aaditsh', 'Aadit Sheth'],
  ['@rabois', 'Keith Rabois'],
  ['@tobi', 'Tobi Lütke'],
  ['@briannekimmel', 'Brianne Kimmel'],
  ['@reidhoffman', 'Reid Hoffman'],
  ['@brianchesky', 'Brian Chesky'],
  ['@patrickc', 'Patrick Collison'],
  ['@danielek', 'Daniel Ek'],
  ['@dharmesh', 'Dharmesh Shah'],
  ['@hunterwalk', 'Hunter Walk'],
  ['@fredwilson', 'Fred Wilson'],
  ['@bfeld', 'Brad Feld'],
  ['@msuster', 'Mark Suster'],
  ['@semil', 'Semil Shah'],
  ['@eriktorenberg', 'Erik Torenberg'],
  ['@shreyas', 'Shreyas Doshi'],
  ['@lennysan', 'Lenny Rachitsky'],
  ['@joulee', 'Julie Zhuo'],
  ['@levelsio', 'Pieter Levels'],
  ['@swyx', 'Shawn Wang'],
  ['@cassidoo', 'Cassidy Williams'],
  ['@addyosmani', 'Addy Osmani'],
  ['@dan_abramov', 'Dan Abramov'],
  ['@kentcdodds', 'Kent C. Dodds'],
  ['@sarahkunst', 'Sarah Kunst'],
  ['@jaltma', 'Jack Altman'],
  ['@chrismessina', 'Chris Messina'],
  ['@alexstamos', 'Alex Stamos'],
  ['@sarahcpr', 'Sarah Cooper'],
  ['@anothercohen', 'Alex Cohen'],
  ['@gregisenberg', 'Greg Isenberg'],
  ['@ankurnagpal', 'Ankur Nagpal'],
  ['@sahilbloom', 'Sahil Bloom'],
  ['@girdley', 'Michael Girdley'],
  ['@karaswisher', 'Kara Swisher'],
  ['@waltmossberg', 'Walt Mossberg'],
  ['@johnmaeda', 'John Maeda'],
  ['@mollyfmielke', 'Molly Mielke'],
  ['@sindresorhus', 'Sindre Sorhus'],
  ['@mjackson', 'Michael Jackson'],
  ['@zeynep', 'Zeynep Tufekci'],
  ['@nntaleb', 'Nassim Nicholas Taleb'],
  ['@asymco', 'Horace Dediu'],
  ['@stewartbrand', 'Stewart Brand'],
  ['@mattyglesias', 'Matthew Yglesias'],
  ['@ezraklein', 'Ezra Klein'],
];
